import React, { useState, useEffect } from "react";
import {
  useDispatch, useSelector,
} from "react-redux";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import Loader from "components/Common/TableLoader";
import { fetchClientDetails } from "store/client/actions";
import { unlinkInvestorFromProfile } from "store/mam-pam/actions";
import { AvForm } from "availity-reactstrap-validation";
import SearchableInvestorAccount from "./SearchableComponents/SearchableInvestorAccounts";
import { fetchProfileBySlaveAccountId } from "apis/mam-profile";
import { getDeductionScheduleName, getProfileName } from "pages/Requests/Master/data";

function UnLinkSP({ isLead, kyc = true, id }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [linkClientModal, setLinkClientModal] = useState(false);
  const [profile, setProfile] = useState();
  const [profileLoading, setProfileLoading] = useState(false);
  const [account, setAccount] = useState();

  const toggleModal = () => {
    setProfile();
    setAccount();
    setLinkClientModal(!linkClientModal);
  };

  const {
    link: { loading },
    clearingCounter,
  } = useSelector((state) => state.mamPamReducer);

  useEffect(() => {
    if (linkClientModal) {
      dispatch(fetchClientDetails(id));
      toggleModal();
    }
  }, [clearingCounter]);

  const handleConfirm = (e, v) => {
    dispatch(unlinkInvestorFromProfile({
      profileId: profile?._id,
      customerId: id,
      investorId: v?.investorAccount?._id,
    }));
  };

  useEffect(() => {
    if (account) {
      setProfileLoading(true);
      fetchProfileBySlaveAccountId({
        slaveTradingAccountId: account?._id,
      }).then((res) => {
        if (res?.docs) {
          setProfile(res?.docs[0]);
        }
      }).finally(() => {
        setProfileLoading(false);
      });
    }
  }, [account]);

  return (
    <React.Fragment >
      <button
        type="button"
        disabled={isLead}
        className="btn btn-primary waves-effect waves-light w-100 me-1"
        onClick={toggleModal}
      >
        {t("UnLink SP")}
      </button>
      <Modal isOpen={linkClientModal} toggle={toggleModal} centered={true}>
        <AvForm
          onValidSubmit={(e, v) => handleConfirm(e, v)}
        >
          <ModalHeader toggle={toggleModal}>
            {t("UnLink Investors to SP")}
          </ModalHeader>
          <ModalBody >
            <Row>
              <Col>
                <SearchableInvestorAccount
                  investor={{
                    _id: id,
                  }}
                  setAccount={setAccount}
                />
              </Col>
            </Row>
            <Row>
              {
                profile && <>
                  {
                    (profileLoading) ? <Loader /> : (
                      <>
                        <Row className="text-center">
                          <h6 className="mb-2">{t("Signal Provider")}: {profile?.customerId?.firstName} {profile?.customerId?.lastName}</h6>
                          <h6 className="mb-2">{getProfileName(profile?.profileType)}</h6>
                          <h6 className="mb-2">{getDeductionScheduleName(profile?.deductionSchedule)}</h6>
                        </Row>
                      </>
                    )
                  }
                </>
              }
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button onClick={toggleModal} color="secondary">
              {t("No")}
            </Button>
            {loading ? <Loader /> : (
              <Button type="submit" color="primary" disabled={!kyc || !profile}>
                {t("Yes")}
              </Button>
            )}
          </ModalFooter>
        </AvForm>
      </Modal>
    </React.Fragment >
  );
}

export default (UnLinkSP);